export default __webpack_public_path__ + "static/media/About_IMG-Wisdom.cc732400.png";